import React from 'react'
import { IconProps } from '../types'

type LogoProps = IconProps & {
  // legacy props kept for compatibility but ignored; this logo always shows image + wordmark
  preferImage?: boolean
  showWordmark?: boolean
}

export const TradovateLogo: React.FC<LogoProps> = (props) => {

  // Extract height from className if present to size both parts consistently
  let computedHeight: number | undefined = typeof props.height === 'number' ? props.height :
    typeof props.height === 'string' ? parseInt(props.height, 10) : undefined

  if (props.className && !computedHeight) {
    const heightMatch = props.className.match(/h-(\d+)/)
    if (heightMatch && heightMatch[1]) {
      const units = parseInt(heightMatch[1], 10)
      computedHeight = units * 4 // Tailwind h-N => N*4 px
    }
  }

  const heightStyle = computedHeight ? { height: `${computedHeight}px` } : undefined
  return (
    // eslint-disable-next-line no-restricted-syntax
    <span className={props.className} onClick={props.onClick} style={{ display: 'inline-flex', alignItems: 'center', ...(props.style || {}) }}>
      <img
        src="/brand/tradovate-logo.svg"
        alt="Tradovate logo"
        // eslint-disable-next-line no-restricted-syntax
        style={{ ...heightStyle, width: 'auto', display: 'block' }}
      />
    </span>
  )
}

export const TradovateLogoNegative = TradovateLogo
